import React from 'react';

export default function Bone() {
	let style = {
		st2: {
 			fill:"#FFFFFF"
		},
	};
	return (
		<g>
			<path style={style.st2} d="M139.3103485,378.6974792c2.6002197-2.0913696,4.2680511-5.2949219,4.2680511-8.89151
				c0-6.3017273-5.1092834-11.4110107-11.411026-11.4110107c-5.1377182,0-9.3689728,3.8449402-11.7977676,8.3145142H85.3362808
				c-2.4287949-4.469574-6.6600494-8.3145142-11.7977676-8.3145142c-6.3017349,0-11.4110222,5.1092834-11.4110222,11.4110107
				c0,3.5965881,1.6678352,6.8001404,4.268055,8.89151c-2.6002197,2.0913696-4.268055,5.2949219-4.268055,8.89151
				C62.127491,393.8907166,67.2367783,399,73.5385132,399c5.1377182,0,9.3689728-3.8449402,11.7977676-8.3145142h35.0329056
				C122.7984009,395.1550598,127.0292358,399,132.1673737,399c6.3017426,0,11.411026-5.1092834,11.411026-11.4110107
				C143.5783997,383.9924011,141.9105682,380.7888489,139.3103485,378.6974792z"/>
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Toy/Bone.js